export const canAccessNavItem = (item, user) => {
  const role = user?.role || 'staff';
  if (!item?.allowedRoles || item.allowedRoles.length === 0) return true;
  if (!item.allowedRoles.includes(role)) return false;
  if (item.pagePermission && (item.pagePermissionRoles || []).includes(role)) {
    return Boolean(user?.page_permissions?.[item.pagePermission]);
  }
  return true;
};

export const canAccessInventory = (user) =>
  canAccessNavItem(
    {
      allowedRoles: ['owner', 'admin', 'production', 'manager'],
      pagePermission: 'inventory',
      pagePermissionRoles: ['manager'],
    },
    user
  );
